<template>
  <div class="div-dropdown-component">
    <single-select
      :value.sync="compValue"
      :value-property="'value'"
      :options="dropdownOptions"
      :readonly="readonly"
    />
    <span v-if="problemToList" class="text-danger">
      {{ errorMessage }}
    </span>
  </div>
</template>
  
  <script>
export default {
  name: "VehicleDropdown",
  props: {
    vehicleId: String,
    vehicles: Array,
    markerType: Number,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "single-select": () => import("@/components_rms/base/SingleSelect.vue"),
  },
  data() {
    return {
      errorMessage: null,
      dropdownOptions: [{ value: null, text: "Selecione o tipo do marcador" }],
    };
  },
  created() {
    if (this.vehicles && this.vehicles != null) {
      this.dropdownOptions = this.vehicles;
    } else {
      this.loadvehicles();
    }
  },
  computed: {
    compValue: {
      get: function () {
        return this.vehicleId;
      },
      set: function (newValue) {
        this.$emit("update:vehicleId", newValue);
      },
    },
    problemToList() {
      return this.errorMessage && this.errorMessage != "";
    },
  },
  methods: {
    loadvehicles() {
      if (this.markerType !== null && this.markerType !== undefined) {
        this.$apiVehicle
          .get("/vehicleRegistration/GetAllDropdown/" + this.markerType)
          .then((response) => {
            this.dropdownOptions = response.data.map((item) => ({
              value: item.value.toString(),
              text: item.text,
            }));
          })
          .catch((error) => {
            this.dropdownOptions = [
              { value: null, text: "Erro ao carregar veículos" },
            ];
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              this.errorMessage = error.message;
            }
          });
      }
    },
  },
  watch: {
    markerType: function () {
      this.loadvehicles();
    },
  },
};
</script>